import { WidgetComponent } from './app/widget-host/widget-host.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { widgetConfig } from './widget.config';

bootstrapApplication(WidgetComponent, widgetConfig).catch((err) => console.error(err));

